<template>
  <div class="explore-page">
    <!-- 英雄区域头部 -->
    <section class="explore-hero">
      <div class="container">
        <div class="explore-hero-content">
          <h1 class="hero-title">科学解非遗</h1>
          <p class="hero-subtitle">
            探索中华民族深厚的文化底蕴，体验传统技艺的独特魅力，
            通过现代教学方法感受非物质文化遗产的永恒价值
          </p>
        </div>
      </div>
    </section>

    <!-- 主要内容区域 -->
    <main>
      <!-- 精选项目展示 -->
      <section class="projects-showcase">
        <div class="container">
          <div class="showcase-title">
            <h2>精选非遗项目</h2>
            <p>每一项非物质文化遗产都承载着深厚的历史文化内涵，结合现代教学方法传承文化精髓</p>
          </div>
          
          <div class="projects-grid-refined">
            <div 
              v-for="(project, index) in featuredProjects" 
              :key="project.id"
              class="heritage-card-premium fade-in-up"
              :class="project.cardClass"
              :style="{ 'animation-delay': `${(index + 1) * 0.1}s` }"
              @click="handleProjectClick(project)"
            >
              <div class="card-background" :style="project.backgroundStyle"></div>
              <div class="card-content-premium">
                <span class="teaching-method">{{ project.teachingMethod }}</span>
                <h3 class="heritage-title">{{ project.title }}</h3>
                <p class="heritage-description">{{ project.description }}</p>
                <div class="heritage-meta">
                  <div class="meta-item-premium">
                    <i class="fas fa-map-marker-alt"></i>
                    <span>{{ project.location }}</span>
                  </div>
                  <div class="meta-item-premium">
                    <i class="fas fa-clock"></i>
                    <span>{{ project.origin }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 体验区域 -->
      <section class="experience-modern">
        <div class="container">
          <div class="experience-content">
            <div class="showcase-title">
              <h2>多样化学习体验</h2>
              <p>运用现代教育理念，结合传统文化特色，提供多元化的非遗学习途径</p>
            </div>
            
            <div class="experience-grid-modern">
              <div 
                v-for="experience in experienceOptions" 
                :key="experience.id"
                class="experience-card-modern"
                @click="handleExperienceClick(experience)"
              >
                <div class="experience-icon-modern">
                  <i :class="experience.icon"></i>
                </div>
                <h3>{{ experience.title }}</h3>
                <p>{{ experience.description }}</p>
                <button class="explore-btn">
                  {{ experience.buttonText }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>

    <!-- 页面底部 -->
    <footer class="main-footer">
      <div class="container">
        <div class="footer-content">
          <div class="footer-section">
            <h4>关于我们</h4>
            <p>致力于保护和传承中华民族非物质文化遗产</p>
          </div>
          <div class="footer-section">
            <h4>快速链接</h4>
            <ul>
              <li><router-link to="/about">认识非遗</router-link></li>
              <li><router-link to="/explore">走近非遗</router-link></li>
              <li><router-link to="/heritage">传习非遗</router-link></li>
            </ul>
          </div>
          <div class="footer-section">
            <h4>联系我们</h4>
            <p>邮箱: info@heritage.cn</p>
            <p>电话: 010-12345678</p>
          </div>
        </div>
        <div class="footer-bottom">
          <p>&copy; 2024 中华非遗. 保留所有权利.</p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'ExplorePage',
  
  data() {
    return {
      /**
       * 精选非遗项目数据
       */
      featuredProjects: [
        {
          id: 1,
          title: '皮影戏传统技艺',
          description: '始于西汉，兴于唐宋，盛于清代的古老戏曲艺术形式，以光影的魅力演绎人生百态，传承千年文化精髓',
          teachingMethod: '探究式教学',
          location: '陕西华县',
          origin: '西汉起源',
          cardClass: 'card-piying',
          backgroundStyle: {
            backgroundImage: "url('img/皮影.jpg')"
          },
          clickAction: '/heritage'
        },
        {
          id: 2,
          title: '英德红茶制作技艺',
          description: '广东英德特产，采用独特的发酵工艺，茶汤红艳明亮，香气浓郁持久，享誉海内外的茶叶瑰宝',
          teachingMethod: '项目式教学',
          location: '广东英德',
          origin: '明代传承',
          cardClass: 'card-tea',
          backgroundStyle: {
            backgroundImage: "url('img/英德红茶.jpg')"
          },
          clickAction: '/heritage'
        },
        {
          id: 3,
          title: '大吴泥塑传统技艺',
          description: '以泥土为原料，运用传统手工技法塑造各种形象，工艺精湛，形神兼备，富有浓郁的民间特色',
          teachingMethod: '问题式教学',
          location: '江苏无锡',
          origin: '明清兴盛',
          cardClass: 'card-sculpture',
          backgroundStyle: {
            backgroundImage: "url('img/大吴泥塑.jpg')"
          },
          clickAction: '/heritage'
        },
        {
          id: 4,
          title: '龙舟竞渡传统',
          description: '端午佳节的重要民俗活动，承载着深厚的历史文化内涵和团结协作的精神品质，传承民族精神',
          teachingMethod: '项目式教学',
          location: '全国各地',
          origin: '战国时期',
          cardClass: 'card-dragon',
          backgroundStyle: {
            backgroundImage: "url('img/龙舟.jpg')"
          },
          clickAction: '/longzhou-teaching'
        }
      ],
      
      /**
       * 体验选项数据
       */
      experienceOptions: [
        {
          id: 1,
          title: '互动式体验',
          description: '通过VR、AR等现代技术，身临其境地感受传统技艺的制作过程和文化内涵',
          icon: 'fas fa-vr-cardboard',
          buttonText: '开始体验',
          clickAction: '/heritage'
        },
        {
          id: 2,
          title: '在线学习课程',
          description: '精心设计的系统化课程，从基础知识到高级技能，循序渐进学习非遗技艺',
          icon: 'fas fa-graduation-cap',
          buttonText: '查看课程',
          clickAction: '/heritage'
        },
        {
          id: 3,
          title: '专家直播讲座',
          description: '邀请非遗传承人和专家学者，定期举办在线讲座，分享传承经验和文化故事',
          icon: 'fas fa-video',
          buttonText: '观看直播',
          clickAction: '/heritage'
        },
        {
          id: 4,
          title: '社区交流平台',
          description: '与全国各地的非遗爱好者交流学习心得，分享作品，共同传承优秀文化',
          icon: 'fas fa-users',
          buttonText: '加入社区',
          clickAction: '/profile'
        }
      ]
    }
  },
  
  mounted() {
    this.initScrollEffects()
    this.initAnimations()
  },
  
  beforeDestroy() {
    this.cleanupEventListeners()
  },
  
  methods: {
    /**
     * 处理项目卡片点击
     * @param {Object} project - 点击的项目
     */
    handleProjectClick(project) {
      console.log('点击了项目卡片:', project.title)
      
      if (project.clickAction) {
        if (project.clickAction.startsWith('/')) {
          this.$router.push(project.clickAction)
        } else {
          window.location.href = project.clickAction
        }
      }
    },
    
    /**
     * 处理体验选项点击
     * @param {Object} experience - 点击的体验选项
     */
    handleExperienceClick(experience) {
      console.log('点击了体验选项:', experience.title)
      
      if (experience.clickAction) {
        if (experience.clickAction.startsWith('/')) {
          this.$router.push(experience.clickAction)
        } else {
          window.location.href = experience.clickAction
        }
      }
    },
    
    /**
     * 初始化滚动效果
     */
    initScrollEffects() {
      this.handleScroll = () => {
        const header = document.querySelector('.main-header')
        if (header) {
          if (window.scrollY > 100) {
            header.classList.add('scrolled')
          } else {
            header.classList.remove('scrolled')
          }
        }
      }
      
      window.addEventListener('scroll', this.handleScroll, { passive: true })
    },
    
    /**
     * 初始化动画效果
     */
    initAnimations() {
      const observerOptions = {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
      }

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.style.opacity = '1'
            entry.target.style.transform = 'translateY(0)'
          }
        })
      }, observerOptions)

      // 观察所有需要动画的元素
      this.$nextTick(() => {
        const animatedElements = document.querySelectorAll('.fade-in-up')
        animatedElements.forEach(el => this.observer.observe(el))
      })
    },
    
    /**
     * 清理事件监听器
     */
    cleanupEventListeners() {
      if (this.handleScroll) {
        window.removeEventListener('scroll', this.handleScroll)
      }
      
      if (this.observer) {
        this.observer.disconnect()
      }
    }
  }
}
</script>

<style scoped>
/* 页面主体样式 */
.explore-page {
  --explore-primary: #1a365d;
  --explore-secondary: #2d5f8c;
  --explore-accent: #4a9eff;
  --explore-light: #f8fafc;
  --explore-card-bg: #ffffff;
  --explore-text: #1a202c;
  --explore-text-light: #64748b;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  min-height: 100vh;
}

/* 现代化页面头部 */
.explore-hero {
  background: linear-gradient(135deg, var(--explore-primary) 0%, var(--explore-secondary) 100%);
  color: white;
  padding: 120px 0 100px;
  position: relative;
  overflow: hidden;
}

.explore-hero::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="grain" width="100" height="100" patternUnits="userSpaceOnUse"><circle cx="25" cy="25" r="0.5" fill="white" opacity="0.1"/><circle cx="75" cy="75" r="0.5" fill="white" opacity="0.1"/><circle cx="50" cy="50" r="0.3" fill="white" opacity="0.05"/></pattern></defs><rect width="100" height="100" fill="url(%23grain)"/></svg>');
  opacity: 0.3;
}

.explore-hero-content {
  position: relative;
  z-index: 2;
  text-align: center;
  max-width: 800px;
  margin: 0 auto;
}

.hero-title {
  font-size: 3.5rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  background: linear-gradient(135deg, #ffffff 0%, #e2e8f0 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-shadow: 0 4px 20px rgba(0,0,0,0.3);
}

.hero-subtitle {
  font-size: 1.25rem;
  opacity: 0.9;
  margin-bottom: 2rem;
  line-height: 1.6;
}

/* 精选项目展示 */
.projects-showcase {
  padding: 80px 0;
}

.showcase-title {
  text-align: center;
  margin-bottom: 4rem;
}

.showcase-title h2 {
  font-size: 2.8rem;
  font-weight: 700;
  color: var(--explore-primary);
  margin-bottom: 1rem;
  position: relative;
}

.showcase-title h2::after {
  content: '';
  position: absolute;
  bottom: -15px;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 4px;
  background: linear-gradient(90deg, var(--explore-accent), var(--explore-secondary));
  border-radius: 2px;
}

.showcase-title p {
  font-size: 1.2rem;
  color: var(--explore-text-light);
  max-width: 700px;
  margin: 0 auto;
  line-height: 1.7;
}

/* 项目网格布局 */
.projects-grid-refined {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 2.5rem;
  margin-top: 4rem;
}

/* 高级项目卡片设计 */
.heritage-card-premium {
  position: relative;
  height: 320px;
  border-radius: 24px;
  overflow: hidden;
  box-shadow: 0 15px 50px rgba(26, 54, 93, 0.15);
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  background: #ffffff;
}

.heritage-card-premium::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(26, 54, 93, 0.3) 0%, rgba(45, 95, 140, 0.5) 100%);
  z-index: 2;
  transition: all 0.4s ease;
}

.heritage-card-premium:hover::before {
  background: linear-gradient(135deg, rgba(26, 54, 93, 0.2) 0%, rgba(45, 95, 140, 0.3) 100%);
}

.heritage-card-premium:hover {
  transform: translateY(-15px) scale(1.02);
  box-shadow: 0 25px 70px rgba(26, 54, 93, 0.25);
}

/* 背景图片 */
.card-background {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  transition: transform 0.5s ease;
}

.heritage-card-premium:hover .card-background {
  transform: scale(1.1);
}

/* 内容区域 */
.card-content-premium {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 2rem;
  z-index: 3;
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.8));
}

/* 教学方法标签 */
.teaching-method {
  display: inline-block;
  background: linear-gradient(135deg, var(--explore-accent), var(--explore-secondary));
  color: white;
  padding: 8px 20px;
  border-radius: 25px;
  font-size: 0.85rem;
  font-weight: 600;
  margin-bottom: 1rem;
  text-transform: uppercase;
  letter-spacing: 1px;
  box-shadow: 0 4px 15px rgba(74, 158, 255, 0.3);
}

/* 项目标题 */
.heritage-title {
  font-size: 1.8rem;
  font-weight: 700;
  color: white;
  margin-bottom: 0.8rem;
  position: relative;
  display: inline-block;
}

.heritage-title::after {
  content: '';
  position: absolute;
  bottom: -5px;
  left: 0;
  width: 60%;
  height: 3px;
  background: linear-gradient(90deg, var(--explore-accent), transparent);
  border-radius: 2px;
}

/* 项目描述 */
.heritage-description {
  color: rgba(255, 255, 255, 0.9);
  line-height: 1.6;
  font-size: 1rem;
  margin-bottom: 1.5rem;
}

/* 项目元信息 */
.heritage-meta {
  display: flex;
  gap: 1.5rem;
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.8);
}

.meta-item-premium {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.meta-item-premium i {
  color: var(--explore-accent);
  font-size: 1rem;
}

/* 体验区域现代化 */
.experience-modern {
  background: white;
  padding: 80px 0;
  margin-top: 60px;
  position: relative;
}

.experience-modern::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(248, 250, 252, 0.8) 0%, rgba(226, 232, 240, 0.3) 100%);
  z-index: 1;
}

.experience-content {
  position: relative;
  z-index: 2;
}

.experience-grid-modern {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 2rem;
  margin-top: 3rem;
}

.experience-card-modern {
  background: white;
  border-radius: 16px;
  padding: 2rem;
  text-align: center;
  box-shadow: 0 8px 30px rgba(26, 54, 93, 0.08);
  transition: all 0.3s ease;
  border: 1px solid rgba(226, 232, 240, 0.5);
}

.experience-card-modern:hover {
  transform: translateY(-8px);
  box-shadow: 0 20px 50px rgba(26, 54, 93, 0.12);
}

.experience-icon-modern {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, var(--explore-accent), var(--explore-secondary));
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1.5rem;
}

.experience-icon-modern i {
  font-size: 2rem;
  color: white;
}

.experience-card-modern h3 {
  font-size: 1.3rem;
  font-weight: 700;
  color: var(--explore-text);
  margin-bottom: 1rem;
}

.experience-card-modern p {
  color: var(--explore-text-light);
  line-height: 1.6;
  margin-bottom: 1.5rem;
}

.explore-btn {
  background: linear-gradient(135deg, var(--explore-accent) 0%, var(--explore-secondary) 100%);
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 10px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  width: 100%;
  font-size: 0.95rem;
}

.explore-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(74, 158, 255, 0.3);
}

/* 动画效果 */
.fade-in-up {
  opacity: 0;
  transform: translateY(30px);
  animation: fadeInUp 0.8s ease forwards;
}

@keyframes fadeInUp {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .hero-title {
    font-size: 2.5rem;
  }
  
  .projects-grid-refined {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
  
  .heritage-card-premium {
    height: 280px;
  }
  
  .heritage-title {
    font-size: 1.5rem;
  }
  
  .showcase-title h2 {
    font-size: 2.2rem;
  }
}

@media (max-width: 480px) {
  .explore-hero {
    padding: 80px 0 60px;
  }
  
  .hero-title {
    font-size: 2rem;
  }
  
  .hero-subtitle {
    font-size: 1.1rem;
  }
  
  .projects-showcase {
    padding: 60px 0;
  }
  
  .heritage-card-premium {
    height: 240px;
  }
  
  .card-content-premium {
    padding: 1.5rem;
  }
  
  .heritage-title {
    font-size: 1.3rem;
  }
  
  .heritage-description {
    font-size: 0.9rem;
  }
}
</style> 